import {
  Box,
  Checkbox,
  CheckboxGroup,
  Divider,
  Flex,
  FormControl,
  FormErrorMessage,
  Grid,
  GridItem,
  HStack,
  Icon,
  Stack,
  Text,
  Tooltip,
  useBreakpointValue,
} from "@chakra-ui/react";
import { Field } from "formik";
import { renderTooltip } from "../../../../../components/RenderTooltip";
import { CustomMultiSelectWField } from "../../../../../components/MultiSelect";
import { CustomInputWField } from "../../../../../components/CustomInputWField";
import { onlyNumbers } from "../../../../../utils/masks";
import { PopoverGenero } from "../../../../../components/PopoverGenero";
import { useCallback, useState } from "react";
import CargaSelecaoService from "../../../../../../main/services/CargaSelecaoService";
import { IoHelpCircle } from "react-icons/io5";

export const DadosBasicosAba = ({ children, props, isMobile }) => {
  const [generos, setGeneros] = useState({ options: [], isLoading: false });
  const placement = useBreakpointValue({ md: "right" });
  const [isOpen, setIsOpen] = useState(false);
  const [hintAnos, setHintAnos] = useState(false);
  const [hintSearch, setHintSearch] = useState(false);
  const [racasCores, setRacasCores] = useState({
    options: [],
    isLoading: false,
  });

  const handleGetRacasCores = () => {
    setRacasCores({ ...racasCores, isLoading: true });
    CargaSelecaoService.getRacasCores().then((res) => {
      const allOption = { id: "", descricao: "Todos" };
      setRacasCores({ options: [allOption, ...res.data], isLoading: false });
    });
  };

  const handleGetGeneros = useCallback(() => {
    setGeneros((prevState) => ({ ...prevState, isLoading: true }));
    CargaSelecaoService.getGeneros().then((res) => {
      res.data.push({
        id: 8,
        genero: "OUTROS",
        descricao: "Descrição do gênero Outros",
      });
      const allOption = { id: "", descricao: "Todos" };
      const tempOptions = res.data.map((genero) => {
        return {
          id: genero.id,
          descricao: genero.descricao,
          genero: genero.genero,
          label: (
            <HStack justifyContent="space-between">
              <Text
                color="#1A203D"
                fontWeight={400}
                fontSize={{ base: "12px", md: "14px" }}
              >
                {genero.genero}
              </Text>

              <Tooltip
                label={genero.descricao}
                fontSize="md"
                textAlign={"justify"}
                width="90%"
              >
                <span className="hint-tooltip">
                  <Icon
                    aria-label="Aviso de pendente"
                    color="#6B6C71"
                    as={IoHelpCircle}
                    boxSize="20px"
                  />
                </span>
              </Tooltip>
            </HStack>
          ),
        };
      });
      setGeneros({ options: [allOption, ...tempOptions], isLoading: false });
    });
  }, []);

  const handleClick = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <Flex mb={4} justifyContent={"space-between"}>
        <Text
          fontWeight={700}
          fontSize="16px"
          lineHeight="21.6px"
          color={"#575553"}
        >
          Dados Básicos
        </Text>
        {children}
      </Flex>

      <Text
        fontWeight={700}
        fontSize="14px"
        lineHeight="21.6px"
        color={"#169499"}
        mt={7}
        mb={2}
      >
        Gênero
      </Text>
      <Divider orientation="horizontal" borderColor={"#DDEBEA"} />
      <Box>
        <Grid
          templateColumns="repeat(15, 1fr)"
          gap="15px"
          mt="15px"
          w="100%"
          alignItems={"center"}
        >
          <GridItem colSpan={{ base: 15, xl: 7, "2xl": 7 }} zIndex={"3"}>
            <Flex alignItems={props.errors.idGenero ? "center" : "end"} gap={2}>
              <CustomMultiSelectWField
                fieldName="idGenero"
                label="Gênero"
                placeholder="Selecione o Gênero"
                getOptionLabel={(option) => option.label || option.descricao}
                getOptionValue={(option) => option.id}
                isLoading={generos.isLoading}
                options={generos.options}
                onChange={(value) => {
                  props.setFieldValue("idGenero", value);
                }}
                values={props?.values?.idGenero[0] || ""}
                onFocus={
                  generos?.options?.length === 0 ? handleGetGeneros : null
                }
                visible
                todos
              />

              {props.values.idGenero && isMobile && (
                <PopoverGenero
                  isOpen={isOpen}
                  setIsOpen={setIsOpen}
                  handleClick={handleClick}
                  labelTextoGenero={
                    props.values?.idGenero?.label?.props?.children[1]?.props
                      ?.label
                  }
                />
              )}
            </Flex>
          </GridItem>
        </Grid>
      </Box>

      <Text
        fontWeight={700}
        fontSize="14px"
        lineHeight="21.6px"
        color={"#169499"}
        mt={7}
        mb={2}
      >
        Raça/Cor
      </Text>
      <Divider orientation="horizontal" borderColor={"#DDEBEA"} />
      <Grid
        templateColumns="repeat(15, 1fr)"
        gap="15px"
        mt="15px"
        w="100%"
        alignItems={"center"}
      >
        <GridItem colSpan={{ base: 15, xl: 7, "2xl": 7 }} zIndex={"2"}>
          <CustomMultiSelectWField
            fieldName="idRaca"
            label="Raça/Cor"
            placeholder="Selecione a Raça/Cor"
            getOptionLabel={(option) => option.raca || option.descricao}
            getOptionValue={(option) => option.id}
            isLoading={racasCores.isLoading}
            options={racasCores.options}
            onChange={(value) => {
              props.setFieldValue("idRaca", value);
            }}
            onFocus={
              racasCores.options.length === 0 ? handleGetRacasCores : null
            }
            values={props?.values?.idRaca[0] || ""}
            visible
            todos
          />
        </GridItem>
      </Grid>

      <Text
        fontWeight={700}
        fontSize="14px"
        lineHeight="21.6px"
        color={"#169499"}
        mt={7}
        mb={2}
      >
        Faixa Etária do Período Pesquisado
      </Text>
      <Divider orientation="horizontal" borderColor={"#DDEBEA"} />
      <Box mt={7}>
        <Grid templateColumns="repeat(12, 1fr)" gap="15px" mt="15px" w="100%">
          <GridItem colSpan={{ base: 9, xl: 8, "2xl": 6 }}>
            <Stack direction="column" gap={4}>
              <Flex gap={4} alignItems="flex-start" flexWrap="wrap">
                <Flex gap={2} alignItems="center" flexShrink={0}>
                  <Text pt="17px">De</Text>
                  <Box minW="50px" maxW="80px">
                    <CustomInputWField
                      fieldName="idadeInicial"
                      placeholder="00"
                      maxLength={2}
                      onChange={(e) =>
                        props.setFieldValue(
                          "idadeInicial",
                          onlyNumbers(e.target.value),
                        )
                      }
                    />
                  </Box>
                </Flex>

                <Flex gap={2} alignItems="center" flexShrink={0}>
                  <Text pt="17px">até</Text>
                  <Box minW="50px" maxW="80px">
                    <CustomInputWField
                      fieldName="idadeFinal"
                      placeholder="00"
                      maxLength={2}
                      onChange={(e) =>
                        props.setFieldValue(
                          "idadeFinal",
                          onlyNumbers(e.target.value),
                        )
                      }
                    />
                  </Box>
                </Flex>

                <Flex pt="17px" gap={3} alignItems="center" flexShrink={0}>
                  <Text>anos</Text>

                  {props?.values?.idadeFinal &&
                    Number(props.values.idadeFinal) <= 15 &&
                    renderTooltip(
                      isMobile,
                      placement,
                      "Faixa Etária informada não habilitará a aba Profissionalização",
                      hintAnos,
                      setHintAnos,
                    )}
                </Flex>
              </Flex>
            </Stack>
          </GridItem>
        </Grid>
      </Box>
      <Flex gap={2} mt={7} mb={2}>
        <Text
          fontWeight={700}
          fontSize="14px"
          lineHeight="21.6px"
          color={"#169499"}
        >
          Pesquisar Fichas
        </Text>
        {renderTooltip(
          isMobile,
          placement,
          "Habilitado somente se marcado Situação atual.",
          hintSearch,
          setHintSearch,
        )}
      </Flex>

      <Divider orientation="horizontal" borderColor={"#DDEBEA"} />
      <Box mt={7}>
        <Field name="pesquisarFichas">
          {({ field, form }) => (
            <FormControl
              isInvalid={
                form.errors.pesquisarFichas && form.touched.pesquisarFichas
              }
              id="pesquisarFichas"
              width="100%"
              maxW="100%"
            >
              <CheckboxGroup
                value={field.value || []}
                onChange={(value) =>
                  props.setFieldValue("pesquisarFichas", value)
                }
              >
                <Stack
                  flexDirection="row"
                  flexWrap="wrap"
                  alignItems={"end"}
                  gap={4}
                >
                  <Checkbox
                    id="checkbox-nome-social"
                    value="S"
                    isDisabled={props?.values?.tipoPeriodo === "D"}
                  >
                    Cadastros com Nome Social
                  </Checkbox>

                  <Checkbox
                    id="checkbox-nome-ficticio"
                    value="F"
                    isDisabled={props?.values?.tipoPeriodo === "D"}
                  >
                    Cadastros com Nome Fictício
                  </Checkbox>
                  <Checkbox
                    id="checkbox-data-nascimento"
                    value="N"
                    isDisabled={props?.values?.tipoPeriodo === "D"}
                  >
                    Cadastro com Data de Nascimento Estimada
                  </Checkbox>
                </Stack>

                <FormErrorMessage mr="-14">
                  {form.errors.pesquisarFichas}
                </FormErrorMessage>
              </CheckboxGroup>
            </FormControl>
          )}
        </Field>
      </Box>
    </>
  );
};
